export function getParameterByName(name, url) {
  let url1 = url;
  if (!url) {
    url1 = window.location.href;
  }
  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url1);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ''));
}


export function downloadPdfFile(file, fileName) {
  const fileURL = URL.createObjectURL(file);
  const a = document.createElement('a');
  a.href = fileURL;
  a.download = fileName; // 使用传入的文件名
  a.click();
  URL.revokeObjectURL(fileURL);
};


// WEBPACK FOOTER //
// ./src/app/utils/utils.js